import { Box, Popover, Typography } from "@mui/material";
import PermissionInfo from "src/components/permissions/permissionInfo";
import useLocales from "src/hooks/useLocales";

interface Props {
  anchorEl: HTMLElement | null;
  handlePopoverClose: () => void;
  title: string;
  locked?: boolean;
  moduleLocked?: boolean;
}

const NavItemPopover = ({
  anchorEl,
  handlePopoverClose,
  title,
  locked,
  moduleLocked,
}: Props) => {
  const { translate } = useLocales();

  return (
    <Popover
      id="mouse-over-popover"
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: 50,
      }}
      sx={{
        pointerEvents: "none",
      }}
      onClose={handlePopoverClose}
      disableRestoreFocus
      PaperProps={{
        sx: {
          bgcolor: "background.paper",
          borderRadius: "4px",
          p: 1,
          px: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        <Typography
          sx={{
            fontWeight: "bold",
            color: "text.greyLight",
            fontSize: "12px",
          }}
          variant="subtitle2"
        >
          {translate(title)}
        </Typography>
        {locked && <PermissionInfo moduleLocked={moduleLocked} />}
      </Box>
    </Popover>
  );
};
export default NavItemPopover;
